import { ChartScales, ICleanChartValue, NullableChartPeriod } from "@components/Charts/CleanChart.control";
import { GetAdminMinerHashStatistic2, GetUserMinerHashStatistic2 } from "@services/http/miners";
import { CleanChartValueConverter } from "@components/Charts/ChartLiveDataSource";

export interface ScaleListItem {
  value: ChartScales;
  label: string;
  visible: boolean;
}

export interface IMinerChartValue {
  speed: number;
  rejectedRate: number;
  state: number;
}

export const scales: ScaleListItem[] = [
  {
    value: ChartScales.Scale5M,
    label: "5m",
    visible: true,
  }, {
    value: ChartScales.Scale15M,  // 2
    label: "15m",
    visible: true,
  }, {
    value: ChartScales.Scale30M,   // 3
    label: "30m",
    visible: false,
  }, {
    value: ChartScales.Scale1H,   // 3
    label: "1h",
    visible: true,
  }, {
    value: ChartScales.Scale1D,   // 4
    label: "1d",
    visible: true,
  }, {
    value: ChartScales.Scale3D,   // 5
    label: "3d",
    visible: false,
  }, {
    value: ChartScales.Scale7D,   // 6
    label: "7d",
    visible: false,
  }, {
    value: ChartScales.Scale10D,  // 7
    label: "10d",
    visible: false,
  }, {
    value: ChartScales.Scale30D,  // 8
    label: "30d",
    visible: false,
  }
]

export function getScalePeriodDaysCount(value: ChartScales): number {
  if (value === ChartScales.Scale3D) return 3;
  if (value === ChartScales.Scale7D) return 7;
  if (value === ChartScales.Scale10D) return 10;
  if (value === ChartScales.Scale30D) return 30;
  return 1;
}


export function getOldOrNewStatistic(
  isAdmin: boolean,
  period: NullableChartPeriod,
  minerId: number,
  scale: ChartScales | null,
): GetAdminMinerHashStatistic2 | GetUserMinerHashStatistic2 {
  return isAdmin
    ? new GetAdminMinerHashStatistic2(
      period.length > 0 ? period[0] : null,
      period.length > 1 ? period[1] : null,
      scale,
      minerId
    )
    : new GetUserMinerHashStatistic2(
      period.length > 0 ? period[0] : null,
      period.length > 1 ? period[1] : null,
      scale,
      minerId
    )
}

export const minerEventToCleanChart: CleanChartValueConverter<IMinerChartValue> = (
  timeInSec: number,
  value: IMinerChartValue
): ICleanChartValue[] => {
  return [{
    datasetIndex: 0,
    timeInSec,
    value: value.speed,
    state: value.state,
  }, {
    datasetIndex: 1,
    timeInSec,
    value: value.rejectedRate,
    state: value.state,
  }];
}